import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '@/views/login/Login.vue'
import MainContainer from '@/layout/MainContainer.vue'
import Plantilla from '@/router/Plantilla/Plantilla'
import NotFound from '@/views/NotFound.vue'

import store from "@/store";
import mapHelper from "@/store/modules/common/map-helper";

Vue.use(VueRouter)

const routes = [

  {
    path: '',
    component: MainContainer,
    children: [
      ...Plantilla,
    ],
    meta: { clave: null, permiso: false }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { clave: null, permiso: false }
  },
  {
    path: '/notfound',
    name: 'NotFound',
    component: NotFound,
    meta: { clave: null, permiso: false }
  },
  {
    path: '/*/',
    name: 'NotFound2',
    component: NotFound,
    meta: { clave: null, permiso: false }
  },
];


const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_SERVER,
  routes
});



router.beforeEach(async (to, from, next) => {

  try{
    store.dispatch(mapHelper.mapmod.SIAHE_AUTH + mapHelper.mapfn.setDatosSesion)
  }catch{
    if (to.name !== 'Login') {
      next({ name: 'Login' })
      return
    } else if (to.name === 'Login') {
      next()
      return
    }
  }
  
  let isAuthenticated = Vue.prototype.$session ? (Vue.prototype.$session.get("token") ? true : false) : false

  if (to.name == 'activacion') {
    next()
    return
  }

  if (isAuthenticated) {
    if (to.name === 'Login') {
      next({ name: 'Inicio' })
      return
    } else if (to.meta.permiso && ! await checkModulePermission(to.meta.clave)) {
      next({ name: 'NotFound' })
      return
    } else {
      next()
      return
    }
  } else {
    if (to.name !== 'Login') {
      next({ name: 'Login' })
      return
    } else if (to.name === 'Login') {
      next()
      return
    }
  }
})

// router.beforeEach((to, from, next) => {

//   let isAuthenticated = Vue.prototype.$session ? (Vue.prototype.$session.get("token") ? true : false) : false
//   if (to.name == 'activacion'){
//     next()
//   }
//   else if (to.name !== 'Login' && !isAuthenticated){
//     next({ name: 'Login' })
//   }else if(to.name === 'Login' && isAuthenticated){
//     next({ name: '/' })
//   }else{
//     next()
//   }
// })

const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
};

export default router;
